<template>
 <div class="card">
   <recipe-info class="step-box" />

   <div class="code-box">
     <img :src="codeUrl" class="code" />
     <h4>{{ $t('扫码修改菜谱') }}</h4>
   </div>
 </div>
</template>

<script>
import RecipeInfo from "@/components/recipe-info/RecipeInfo";
import {request} from "@/config/request";
import Qrcode from "qrcode";
export default {
  name: "RecipeDetail",
  components: {RecipeInfo},
  data() {
    return {
      codeUrl: ""
    }
  },
  mounted() {
    this.handleCreateCode();
  },
  methods: {
    async handleLoadDetail() {
      try {
        let res = await request(this.$api.cookbook.detail, this.$route.query);
        this.$store.commit("RECIPE_DETAIL", res.cookbook);
      }catch(e) {
         console.log(e);
      }
    },

    // 生成食谱二维码
    handleCreateCode() {
      Qrcode.toDataURL(JSON.stringify(this.$route.query)).then(url => {
        this.codeUrl = url;
      })
    }
  },
  created() {
    this.handleLoadDetail();
  }
}
</script>

<style scoped>

.card {
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 20px;
}

.step-box {
  flex: 1;
  margin-right: 20px;
}

.code-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.code {
  width: 140px;
  height: 140px;
  margin-bottom: 8px;
}

</style>
